<template>
    <div class="alert alert-danger">
        Something went wrong loading your data, please try again. 
        If the problem persists, please contact the support team.
    </div>
</template>

<script>
    export default {
        props: {
            error: Object
        }
    }
</script>